import React, { useState } from 'react';
import { Search } from 'lucide-react';

export const TeamShareSection = ({ team, selectedUsers, setSelectedUsers }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter team members based on search
  const filteredTeam = team.filter(member => 
    member.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
    member.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleUserSelection = (email) => {
    if (selectedUsers.includes(email)) {
      setSelectedUsers(selectedUsers.filter(u => u !== email));
    } else {
      setSelectedUsers([...selectedUsers, email]);
    }
  };

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-gray-300">Team Members</h4>
      
      {/* Search */}
      <div className="relative">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search team members..."
          className="w-full pl-10 pr-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
      </div>
      
      {/* Team Members List */}
      <div className="max-h-40 overflow-y-auto">
        {filteredTeam.length > 0 ? (
          <div className="space-y-2">
            {filteredTeam.map((member, index) => (
              <div 
                key={index} 
                className="flex items-center justify-between p-2 bg-gray-700 rounded-lg"
              >
                <div>
                  <div className="text-white font-medium">{member.name || 'Unnamed User'}</div>
                  <div className="text-sm text-gray-400">{member.email}</div>
                </div>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(member.email)}
                    onChange={() => toggleUserSelection(member.email)}
                    className="rounded border-gray-600 text-blue-500 focus:ring-blue-500 bg-gray-700"
                  />
                </label>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-2 text-gray-400">
            {team.length === 0 ? 'No team members available' : 'No matching team members'}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamShareSection;